import type { customerReviews } from '~/types/local-types'
import { apiCall } from '~/composables/apiCall'
import { reviewsQuery } from '~/graphql/queries/reviews.query.gql'

export const reviews = defineStore('reviews', {
    state: (): customerReviews => <customerReviews>({
        allReviews: {},
        reviewStats: {},
        currentPage: 1,
        currentAmount: 10
    } as customerReviews),
    getters: {
        hasReviews: state => {
            return state.reviewStats?.hasReviewsEnabled && (state.allReviews?.data && Object.keys(state.allReviews?.data).length > 0)
        },
        hasReviewsEnabled: state => {
            return state.reviewStats?.hasReviewsEnabled
        }
    },
    actions: {
        async fetchReviewStats () {
            if (Object.keys(this.reviewStats).length === 0) {
                return this.reviewStats = await apiCall(reviewsQuery, 'getCustomerReviewStatistics', {}, false)
            }
        },
        async fetchCustomerReviews (amount: number, page: number) {
            if (!this.hasReviewsEnabled) {
                return
            }
            if (this.currentPage === page && this.currentAmount === amount && this.allReviews?.data?.length > 0) {
                return
            }
            this.currentPage = page
            this.currentAmount = amount
            return this.allReviews = await apiCall(reviewsQuery, 'customerReviews', { first: amount, page }, false)
        }
    }
})

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(reviews, import.meta.hot))
}
